import { LoadingOrEmptyWrapper } from "components/LoadingAndEmptyHandler";
import { StrandingChartWithEchart } from "components/Modernization/StrandingChartWithEchart";
import { WizardContextProvider } from "context/Wizard";

import { useCrremChartSource } from "../hooks/useCrremChartSource";
import { CrremPathwayChart } from "./CrremPathwayChart";
import { CrremPathwayEmptyState } from "./CrremPathwayEmptyState";

type CrremPathwayOrLegacyChartProps = {
  className?: string;
  projectId: string;
  title: string;
};

export const CrremPathwayOrLegacyChart = ({ className, projectId, title }: CrremPathwayOrLegacyChartProps) => {
  const source = useCrremChartSource(projectId);
  if (!source) {
    return <LoadingOrEmptyWrapper height="53.5rem" showLoading />;
  }
  if (source === "new") {
    return <CrremPathwayChart className={className} projectId={projectId} title={title} />;
  }
  if (source === "legacy") {
    return (
      <WizardContextProvider defaultQuantity="emission" hasModernization={false} projectId={projectId}>
        <StrandingChartWithEchart
          chartHeight="28.5rem"
          className="h-[45.5rem] w-full border-none bg-transparent"
          hasModernization={false}
          projectId={projectId}
          title={title}
        />
      </WizardContextProvider>
    );
  }
  return <CrremPathwayEmptyState className={className} projectId={projectId} title={title} />;
};
